export const uploadAllowedImagesMimeTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/svg+xml',
  'image/webp',
  // 'image/heic',
  // 'image/avif',
];

export const uploadAllowedMimeTypes = [
  ...uploadAllowedImagesMimeTypes,
  'application/pdf',

  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',

  'text/csv',
  'application/zip',
  'text/calendar',

  'application/rtf',
  'application/vnd.apple.pages',
  'application/vnd.apple.numbers',
  'application/vnd.apple.keynote',

  'application/font-woff', // for font upload
  'font/woff',
  'font/woff2',

  'video/mp4',
  // 'video/x-msvideo',
  // 'video/x-ms-wmv',
  // 'video/ogg',
  // 'video/webm',
  // 'video/quicktime',
  // 'video/x-flv',
  // 'video/x-matroska',

  'audio/mpeg',
  // 'audio/x-wav',
  // 'audio/ogg',
  // 'audio/mp4',
  // 'audio/webm',
  // 'audio/midi',
  // 'audio/x-aac',
  // 'audio/x-flac',
  // 'audio/x-wav',
];

export const allowedAIMimeTypes = [
  ...uploadAllowedImagesMimeTypes,
  'application/pdf',
];

export const allowedConvertToPdfMimeTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',

  'application/rtf',
  'application/vnd.apple.pages',
  'application/vnd.apple.numbers',
  'application/vnd.apple.keynote',
];
